import React, { Component } from 'react';
import $ from 'jquery';
import * as Reqst from '../../../utils/Reqst';
import Sanitize from '../../../utils/Sanitize';
import { notify } from 'react-notify-toast';
import { Row, Col } from 'react-bootstrap';
import { CountryDropdown, RegionDropdown } from 'react-country-region-selector';

class Edit extends Component {
	constructor(props) {
		super(props);
		this.state = {
			loginId: Sanitize.getData('labUser_id'),
			companyId: Sanitize.getData('labUser_clientid'),
			masterId: Sanitize.getData('labUser_masterid'),
			saveText: 'UPDATE',
			isRedirect: false,
			showLoader: false,
			editData: this.props.editData,
			country: '',
			region: ''
		}

		this.handleFormSubmit = this.handleFormSubmit.bind(this);
	}

	selectCountry(val) {
		this.setState({ country: val });
	}

	selectRegion(val) {
		this.setState({ region: val });
	}

	handleFormSubmit(e) {
		e.preventDefault();
		this.setState({ showLoader: true, saveText: 'Updating..' });
		var formData = Sanitize.objectifyForm($("#frmAdd").serializeArray());
		Reqst.axPost('school/updatespecialtr', { token: Reqst.Token(formData) }).then(res => {
			if (res['data'].status == '1') {
				notify.show(res['data'].msg, 'success');
				this.setState({ showLoader: false, saveText: 'UPDATE' });
				if (this.props.afterFinish) this.props.afterFinish();
			}
			else {
				notify.show(res['data'].msg, 'error');
				this.setState({ showLoader: false, saveText: 'UPDATE' });
			}
		});
	}

	getData(field) {
		var l = this.state.editData;
		return l[field];
	}

	setData(field, e) {
		var l = this.state.editData;
		l[field] = e.target.value;
		this.setState({ editData: l });
	}

	render() {

		const { country, region } = this.state;

		return (
			<div>
				<form action="" method="post" encType="multipart/form-data" id="frmAdd" onSubmit={this.handleFormSubmit} >
					<input type="hidden" name="i__id" value={this.getData('id')} />
					<input type="hidden" name="i__lid" value={this.state.loginId} />
					<input type="hidden" name="i__company" value={this.state.companyId} />
					<input type="hidden" name="i__master" value={this.state.masterId} />
					<Row>
						<Col md={12} >
							<label>Name<span className="text-danger">*</span></label>
							<input type="text" name="i__name" id="i__name" className="form-control input-sm" required value={this.getData('name')} onChange={this.setData.bind(this, 'name')} />
						</Col>
					</Row>
					<Row>
						<Col md={12} >
							<br />
							<div className="text-right" >
								<button type="submit" className="btn btn-info btn-sm btn-success_2" disabled={this.state.saveText != 'UPDATE'} >
									<i className="fa fa-check"></i> {this.state.saveText}
								</button>
							</div>
						</Col>
					</Row>
				</form>
			</div>
		);
	}

}
export default Edit;